module.exports = __webpack_public_path__ + "media/src/pages/PreApplication/images/success-2-9748dda169123280e1bde2cb5c11922f.png";